import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Page0Landing from './pages/Page0Landing';
import Page2Discovery from './pages/Page2Discovery';
import Page3VMConfig from './pages/Page3VMConfig';
import Page4KeyVault from './pages/Page4KeyVault';
import Page5StorageAccount from './pages/Page5StorageAccount';
import Page6LogAnalytics from './pages/Page6LogAnalytics';
import Page7Tags from './pages/Page7Tags';
import Page8Preview from './pages/Page8Preview';
import Page9CodeViewer from './pages/Page9CodeViewer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Page0Landing />} />
          <Route path="/page2" element={<Page2Discovery />} />
          <Route path="/page3" element={<Page3VMConfig />} />
          <Route path="/page4" element={<Page4KeyVault />} />
          <Route path="/page5" element={<Page5StorageAccount />} />
          <Route path="/page6" element={<Page6LogAnalytics />} />
          <Route path="/page7" element={<Page7Tags />} />
          <Route path="/page8" element={<Page8Preview />} />
          <Route path="/page9" element={<Page9CodeViewer />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
